import { useDispatch, useSelector } from 'react-redux';

import {
  Tooltip,
  HighlightFocusedBodiesIcon,
} from '@frontend/legacy-components';

import { focusedViewToggle } from 'modules/common/viewer/cadViewer/data/actions';
import { getIsFocusedViewActive } from 'modules/common/viewer/cadViewer/data/reducer';
import {
  ViewerButton,
  ViewerButtonTooltip,
} from 'modules/common/viewer/components';

const FocusedViewTool = ({ isEnabled }) => {
  const dispatch = useDispatch();
  const isActive = useSelector(getIsFocusedViewActive);
  if (isEnabled) {
    return (
      <Tooltip
        placement="bottom"
        label={
          <ViewerButtonTooltip
            firstLine="Highlighted focused bodies view"
            secondLine="Show the focused bodies as solid/opaque and other selected bodies as slightly transparent"
          />
        }
      >
        <ViewerButton
          isActive={isActive}
          aria-label="Highlighted focused bodies view"
          onClick={() => dispatch(focusedViewToggle())}
        >
          <HighlightFocusedBodiesIcon boxSize={3} />
        </ViewerButton>
      </Tooltip>
    );
  } else {
    return null;
  }
};

export default FocusedViewTool;
